<angular-editor [config]="config"></angular-editor>